
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { DistrictDDLAPI, GenderDDLAPI } from '../../Helper/Redux/DDLSlice/DDLSlice'
import { useAuthState } from '../../Helper/Context/context'


export const DistrictDDL = (props) => {
    const { DistrictDDLID, setDistrictDDLID, Flag, data, Language, M_IndicatorGrievanceAreaID, UserID, WithoutRegistration } = props

    const userDetails = useAuthState();
    const { RoleID, DistrictID, DistrictName } = userDetails

    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_IndicatorGrievanceAreaID: M_IndicatorGrievanceAreaID,
            Language: Language.Label,
            M_UserID: UserID ? UserID : '0',
        }
        dispatch(DistrictDDLAPI({ data }))
    }, [Language.Label, M_IndicatorGrievanceAreaID])

    const { DDLData } = useSelector(state => state.DistrictDDLData)

    useEffect(() => {
        handleDDL()
    }, [DDLData])

    // console.log("DDLData",DDLData)

    const handleDDL = () => {
        if (DDLData && DDLData.length > 0) {
            let list = DDLData.map((item, index) => ({
                value: item.valueID,
                label: item.valueParam,
            }))

            if (Flag == 'Update') {
                setDistrictDDLID({
                    DDL: list,
                    ID: Flag == 'Update' ? data?.m_DistrictID : 0,
                    Label: Flag == 'Update' ? data?.distrcitName : "Select...",
                })
            }
            else if ((RoleID == 5 || RoleID == 6) && Flag != 'Update') {
                setDistrictDDLID({
                    DDL: list,
                    ID: DistrictID ? DistrictID : 0,
                    Label: DistrictName ? DistrictName : "Select...",
                })
            }
            else {
                setDistrictDDLID({
                    DDL: list,
                    ID: 0,
                    Label: "Select...",
                })
            }
        }
        else {
            setDistrictDDLID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <Select
                id='DistrictID'
                classNamePrefix='am-select'
                isClearable={true}
                isSearchable
                maxMenuHeight={150}
                value={{ value: DistrictDDLID.ID, label: DistrictDDLID.Label }}
                onChange={(e) => {
                    e ?
                        setDistrictDDLID({ ...DistrictDDLID, ID: e.value, Label: e.label })
                        :
                        setDistrictDDLID({ ...DistrictDDLID, ID: 0, Label: "Select..." })

                }}
                options={DistrictDDLID.DDL}
            />
        </div>
    )
}